









import Vue from "vue";
// import IsMobile from "@/mixins/IsMobile";
export default Vue.extend({
  // mixins: [IsMobile],
  data() {
    return {
      mobile: null,
      display: null
    };
  },
  methods: {
    onclick() {
      if (window.innerHeight < 992) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    }
  },
  props: {
    data: {
      type: String,
      required: true
    }
  }
});
